/*eslint-disable */
export const CREATION_TEMPLATE = {id: "CREATION_TEMPLATE", name: "Create new bulk user"};

export const REACTIVATION_TEMPLATE = {id:"REACTIVATION_TEMPLATE", name: "Re-activate bulk user"};

export const UPLOAD_TYPES = [CREATION_TEMPLATE, REACTIVATION_TEMPLATE];

export const EXCEL_ROW_OFFSET = 2;

export const CREATION_TEMPLATE_FIELDS = [];

export const REACTIVATION_TEMPLATE_FIELDS = [];